<template>
  <v-expansion-panel v-model="expanded" v-bind="$attrs">
    <v-expansion-panel-content>
      <template v-slot:header>
        <div class="panel-header-indicator">
          <v-switch readonly :value="expanded === 0" :disabled="$attrs.disabled" class="mt-0 pt-0" color="primary" hide-details>
            <template v-slot:label>
              <label class="body-2 font-weight-bold">{{ label }}</label>
            </template>
          </v-switch>
        </div>
      </template>
      <slot></slot>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
export default {
  name: 'ExpendableOption',
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: Boolean,
      default: undefined
    }
  },
  computed: {
    expanded: {
      get () {
        return this.value ? 0 : undefined
      },
      set (value) {
        this.$emit('input', value === 0)
      }
    }
  }
}
</script>

<style scoped>
.panel-header-indicator {
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/components/forms/ExpendableOption.vue